import { DATE_DISPLAY_FORMAT } from 'pages/TrackAndTrace/config';
import * as React from 'react';
import { Container, LegacyContainerStatus } from 'types/Watchlist';
import { formatCurrencyNumber, formatDate } from 'utils/common';
import { Cell } from './Cell';

import { CellProps } from './types';
import { parsePickupInfo } from './utility';

const baseClassName = 'flex flex-col space-y-2 items-center text-center';

export const LastFreeDayCell: React.FC<CellProps> = (params) => {
  const container: Container = params.row;
  const { pickupInfo, status } = container;

  const {
    pickupLastFreeDay,
    demurrageFeeUsCents,
    demurrageDue,
    timezone,
    demurrageDisplayAlert,
    demurrageNumberOfDays,
  } = parsePickupInfo(pickupInfo);

  const isImport = status === LegacyContainerStatus.Import;

  const LastFreeDayContent = React.useCallback(() => {
    if (!pickupLastFreeDay) return null;

    return (
      <div className="flex items-center space-x-2">
        <h5>{formatDate(pickupLastFreeDay, DATE_DISPLAY_FORMAT, timezone) || '-'}</h5>
        {demurrageDisplayAlert && (
          <h6
            className={`${isImport ? 'text-red-900' : 'text-gray-600'} font-medium`}
            // necessary because items-center doesn't result in quite what's wanted since they're different font sizes
            style={{ paddingTop: '2px' }}
          >
            +{demurrageNumberOfDays}
          </h6>
        )}
      </div>
    );
  }, [pickupLastFreeDay, isImport, demurrageNumberOfDays, timezone, demurrageDisplayAlert]);

  if (!pickupLastFreeDay && !demurrageDue && !demurrageFeeUsCents) {
    return <Cell className={baseClassName}>-</Cell>;
  }

  return (
    <Cell className={baseClassName}>
      <>
        <LastFreeDayContent />
        {demurrageFeeUsCents || demurrageDue ? (
          <h6 className={`${isImport ? 'text-red-900' : 'text-gray-700'} uppercase font-medium`}>
            Demurrage {isImport ? 'due' : ''}{' '}
            {demurrageFeeUsCents ? `(${formatCurrencyNumber(demurrageFeeUsCents)})` : ''}
          </h6>
        ) : null}
      </>
    </Cell>
  );
};
LastFreeDayCell.displayName = 'ContainerTable.LastFreeDayCell';
